function randomString(length = 20) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let str = ''
  for (let i = 0; i < length; i += 1) {
    str += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return str
}

function hexToRGBA(hex, alpha = 1) {
  if (!hex) return
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')'
  }
}
function getRandomColor() {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

function getStrongColorHex() {
  const hue = Math.floor(Math.random() * 360)
  const saturation = (Math.floor(Math.random() * 21) + 80) / 100
  const lightness = (Math.floor(Math.random() * 11) + 45) / 100

  const a = saturation * Math.min(lightness, 1 - lightness)
  const f = n => {
    const k = (n + hue / 30) % 12
    const color = lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0')
  }
  return `#${f(0)}${f(8)}${f(4)}`.toUpperCase()
}

function deepAccess(obj, path) {
  return path.split('.').reduce((acc, part) => (acc && acc[part] ? acc[part] : undefined), obj)
}

function getGradientColor(color1, color2, value) {
  const p = value / 100

  const hex = c => parseInt(c.replace('#', ''), 16)
  const c1 = hex(color1)
  const c2 = hex(color2)

  const r1 = c1 >> 16,
    g1 = (c1 >> 8) & 0xff,
    b1 = c1 & 0xff
  const r2 = c2 >> 16,
    g2 = (c2 >> 8) & 0xff,
    b2 = c2 & 0xff

  const r = Math.round(r1 + (r2 - r1) * p)
  const g = Math.round(g1 + (g2 - g1) * p)
  const b = Math.round(b1 + (b2 - b1) * p)

  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}

/**
 * Converts multiple filter groups into a single Disjunctive Normal Form (DNF) array.
 * Performs a Cartesian product across all groups to maintain an (OR of ANDs) structure.
 *
 * @param {...(Object|Object[]|Object[][])} groups - Filter groups to be combined with AND logic.
 * - Object: Treated as a single required condition.
 * - Object[]: Treated as a list of OR options.
 * - Object[][]: Treated as an existing DNF structure.
 * @returns {Object[][]} A 2D array where the outer level is OR and the inner level is AND.
 */
function buildDNF(...groups) {
  const normalizedGroups = []
  for (const g of groups) {
    if (g === null || g.length === 0) continue
    if (!Array.isArray(g)) {
      normalizedGroups.push([[g]])
    } else if (!Array.isArray(g[0])) {
      normalizedGroups.push(g.map(item => [item]))
    } else {
      normalizedGroups.push(g)
    }
  }

  let result = [[]]

  for (const currentGroup of normalizedGroups) {
    const nextResult = []
    for (const existingPath of result) {
      for (const newPath of currentGroup) {
        nextResult.push([...existingPath, ...newPath])
      }
    }
    result = nextResult
  }

  return result
}

function roundToDecimalPlaces(raw, places = 2) {
  if (raw === null || raw === undefined || typeof raw !== 'number') return raw
  return +raw.toFixed(places)
}
export { randomString, hexToRGBA, deepAccess, buildDNF, getGradientColor, roundToDecimalPlaces, getRandomColor, getStrongColorHex }
